//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { AutoCompSettingsPreviewInput, AutoGroupListingsPreview, AutoGroupListingsPreviewInput, BatchSwapListingGroupInput, BulkMergeListingsInput, ChangeListingOfficeInput, CompListing, DuplicateListingDetails, EntitiesWithSummaryOfListing, EntitiesWithSummaryOfListingWithCatalogData, EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData, FileResponse, Listing, ListingAggregationResponse, ListingAggregationSummary, ListingDetailDataField, ListingDetails, ListingDetailsAutoPricingSectionUpdates, ListingDetailsAutoPricingSectionUpdatesV2, ListingDetailsBroadcastSectionUpdates, ListingDetailsPricingSectionUpdates, ListingDetailsPricingUpdates, ListingDetailsTagsSectionUpdates, ListingDetailsTicketSectionUpdates, ListingDetailsUpdateInput, ListingExperiment, ListingGroup, ListingMergeSuggestion, ListingNote, ListingPriceCalculation, ListingPriceHistory, ListingPricingSectionPosFieldUpdates, ListingQuery, ListingQueryV2, ListingSearchRequestV2, ListingStatusInfo, ListingWithCatalogData, Marketplace, MergeListingGroupInput, MergeListingsInput, MergedListingSectionTypeResolutionResult, MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2, PosUiActionResult, PosUiActionResultWithDataOfAutoCompListingsPreview, PosUiActionResultWithDataOfAutoGroupListingsPreview, PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput, PosUiActionResultWithDataOfIEnumerableOfNullableLong, PosUiActionResultWithDataOfLong, ProblemDetails, ReorderListingInGroupInput, RetailSaleListingTickets, SeatSaverListingDetailsInput, SectionalListingsForEventsInput, SecureListingSearchMappedResult, SplitListingInput, TicketBarcode, TicketExternalId, TicketUrl, UserDocument, ValueTupleOfBooleanAndIListOfTicket, ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig, ValueTupleOfLongAndListingDetailsUpdateInput, ValueTupleOfLongAndNullableInteger } from './types';


export interface IListingClient {

    getListingByListingId(inventoryId: number | undefined, current: ListingDetails | undefined, dataToInclude: ListingDetailDataField[] | null | undefined): Promise<ListingDetails>;

    getListingAvailableQuantitiesByListingIds(inventoryIds: number[]): Promise<number>;

    getListingByMarketplaceListingId(marketplaceListingId: string | undefined): Promise<Listing[]>;

    getListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    searchListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    searchListingsForEventsV2(query: ListingQueryV2): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData>;

    searchListingsForEventsV2Summary(query: ListingQueryV2): Promise<ListingWithCatalogData>;

    getListingsSectionalDataForEvents(input: SectionalListingsForEventsInput, dataToInclude: ListingDetailDataField[] | undefined, processListingGroup: boolean | null | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    getRetailSaleListingTicketsForEvents(input: SectionalListingsForEventsInput): Promise<RetailSaleListingTickets[]>;

    getListingsCanBeWasted(inventoryId: number | undefined): Promise<ValueTupleOfBooleanAndIListOfTicket>;

    getDuplicateListingsForListingId(inventoryId: number | undefined): Promise<DuplicateListingDetails[]>;

    getListingEnabledForAutoPricing(posEventIds: string[]): Promise<boolean>;

    updateAutoPricingEnabledForEvent(posEventIds: string[], autoPricingState: boolean | undefined): Promise<boolean>;

    createMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined): Promise<boolean>;

    deleteMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined): Promise<boolean>;

    updateListingAdminHold(listingId: number | undefined, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined): Promise<PosUiActionResult>;

    updateListingIgnoreDuplicate(listingId: number | undefined, ignoreDuplicate: boolean | undefined): Promise<boolean>;

    updateListingByListingId(listingId: number, input: ListingDetailsUpdateInput): Promise<PosUiActionResult>;

    updateListingPrices(listingId: number | undefined, listPrice: number | undefined, netProceedsFloor: number | undefined): Promise<Listing>;

    updateListingsPricingSettingsByListingId(listingId: number, input: ValueTupleOfLongAndListingDetailsUpdateInput): Promise<Listing>;

    mergeListingsWithListingId(listingId: number, input: MergeListingsInput): Promise<PosUiActionResult>;

    bulkMergeListings(input: BulkMergeListingsInput): Promise<boolean>;

    getMergedListingSectionTypeResolutions(listingIdLists: number[][]): Promise<MergedListingSectionTypeResolutionResult[]>;

    getListingMergeSuggestionsByEvent(viagogoEventId: number | undefined, excludeHeldListings: boolean | null | undefined): Promise<ListingMergeSuggestion[]>;

    getListingMergeSuggestions(excludeHeldListings: boolean | null | undefined): Promise<ListingMergeSuggestion[]>;

    splitListingsByListingId(listingId: number, input: SplitListingInput): Promise<PosUiActionResult>;

    updateBarcodesForListing(listingId: number | undefined, barcodes: TicketBarcode[]): Promise<PosUiActionResult>;

    updateETicketsForListing(listingId: number | undefined, etickets: UserDocument[]): Promise<PosUiActionResult>;

    updateMobileQRCodesForListing(listingId: number | undefined, mobileQRCodes: UserDocument[]): Promise<PosUiActionResult>;

    updateExternalIdsForListing(listingId: number | undefined, externalIds: TicketExternalId[]): Promise<PosUiActionResult>;

    updateTicketUrlsForListing(listingId: number | undefined, ticketUrls: TicketUrl[]): Promise<PosUiActionResult>;

    updateProofOfPurchaseForListing(listingId: number | undefined, proofDocs: UserDocument[]): Promise<PosUiActionResult>;

    getPriceHistoryByListingIdWithListingId(listingId: number, input: ValueTupleOfLongAndNullableInteger): Promise<ListingPriceHistory[]>;

    getCompListingsByEventId(viagogoEventId: number | undefined, listingId: number | null | undefined, currency: string | null | undefined): Promise<CompListing[]>;

    getListingPriceCalculation(viagogoEventId: number | undefined, listingId: number | undefined, officeId: number | null | undefined, input: ListingDetailsPricingUpdates): Promise<ListingPriceCalculation>;

    exportListings(input: ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig): Promise<FileResponse>;

    createSeatSaver(inputs: SeatSaverListingDetailsInput[]): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong>;

    deleteSeatSaver(listingId: number | undefined): Promise<PosUiActionResult>;

    batchSwapListingGroup(input: BatchSwapListingGroupInput): Promise<{ [key: string]: Listing[]; }>;

    reorderListingInGroup(input: ReorderListingInGroupInput): Promise<{ [key: string]: Listing[]; }>;

    updateListingBroadcastSectionByListingId(listingId: number, input: ListingDetailsBroadcastSectionUpdates): Promise<PosUiActionResult>;

    updateListingTicketSectionByListingId(listingId: number, input: ListingDetailsTicketSectionUpdates): Promise<PosUiActionResult>;

    updateListingPricingSectionFromListingTable(listingId: number, input: ListingPricingSectionPosFieldUpdates): Promise<PosUiActionResult>;

    updateListingPricingSectionByListingId(listingId: number, input: ListingDetailsPricingSectionUpdates): Promise<PosUiActionResult>;

    updateListingAutoPricingSectionByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdates): Promise<PosUiActionResult>;

    updateListingAutoPricingSectionV2ByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdatesV2): Promise<PosUiActionResult>;

    updateListingTagSectionByListingId(listingId: number, input: ListingDetailsTagsSectionUpdates): Promise<PosUiActionResult>;

    downloadMergedUserDocumentsPdf(listingId: number | undefined): Promise<FileResponse>;

    getListingStatusByListingId(inventoryId: number | undefined): Promise<ListingStatusInfo>;

    getListingStatusByListingIds(inventoryIds: number[]): Promise<(ListingStatusInfo | null)[]>;

    getLastBroadcastListingMarketplaceByListingId(listingId: number | undefined): Promise<Marketplace[]>;

    downloadSeatSaversFileTemplate(includeEventIdFields: boolean | undefined): Promise<FileResponse>;

    changeListingOffice(input: ChangeListingOfficeInput): Promise<PosUiActionResultWithDataOfLong>;
}

export class ListingClient extends PosClientBase implements IListingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getListingByListingId(inventoryId: number | undefined, current: ListingDetails | undefined, dataToInclude: ListingDetailDataField[] | null | undefined, signal?: AbortSignal | undefined): Promise<ListingDetails> {
        let url_ = this.baseUrl + "/api/Listing/GetListingByListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        if (dataToInclude !== undefined && dataToInclude !== null)
            dataToInclude && dataToInclude.forEach(item => { url_ += "dataToInclude=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(current);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingByListingId(_response);
        });
    }

    protected processGetListingByListingId(response: Response): Promise<ListingDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDetails>(null as any);
    }

    getListingAvailableQuantitiesByListingIds(inventoryIds: number[], signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Listing/GetListingAvailableQuantitiesByListingIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingAvailableQuantitiesByListingIds(_response);
        });
    }

    protected processGetListingAvailableQuantitiesByListingIds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getListingByMarketplaceListingId(marketplaceListingId: string | undefined, signal?: AbortSignal | undefined): Promise<Listing[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingByMarketplaceListingId?";
        if (marketplaceListingId === null)
            throw new Error("The parameter 'marketplaceListingId' cannot be null.");
        else if (marketplaceListingId !== undefined)
            url_ += "marketplaceListingId=" + encodeURIComponent("" + marketplaceListingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingByMarketplaceListingId(_response);
        });
    }

    protected processGetListingByMarketplaceListingId(response: Response): Promise<Listing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing[]>(null as any);
    }

    getListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsForEvents?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (doNotProcessListingGroups === null)
            throw new Error("The parameter 'doNotProcessListingGroups' cannot be null.");
        else if (doNotProcessListingGroups !== undefined)
            url_ += "doNotProcessListingGroups=" + encodeURIComponent("" + doNotProcessListingGroups) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsForEvents(_response);
        });
    }

    protected processGetListingsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    searchListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/SearchListingsForEvents?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (doNotProcessListingGroups === null)
            throw new Error("The parameter 'doNotProcessListingGroups' cannot be null.");
        else if (doNotProcessListingGroups !== undefined)
            url_ += "doNotProcessListingGroups=" + encodeURIComponent("" + doNotProcessListingGroups) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsForEvents(_response);
        });
    }

    protected processSearchListingsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    searchListingsForEventsV2(query: ListingQueryV2, signal?: AbortSignal | undefined): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData> {
        let url_ = this.baseUrl + "/api/Listing/SearchListingsForEventsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsForEventsV2(_response);
        });
    }

    protected processSearchListingsForEventsV2(response: Response): Promise<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData>(null as any);
    }

    searchListingsForEventsV2Summary(query: ListingQueryV2, signal?: AbortSignal | undefined): Promise<ListingWithCatalogData> {
        let url_ = this.baseUrl + "/api/Listing/SearchListingsForEventsV2Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsForEventsV2Summary(_response);
        });
    }

    protected processSearchListingsForEventsV2Summary(response: Response): Promise<ListingWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingWithCatalogData>(null as any);
    }

    getListingsSectionalDataForEvents(input: SectionalListingsForEventsInput, dataToInclude: ListingDetailDataField[] | undefined, processListingGroup: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsSectionalDataForEvents?";
        if (dataToInclude === null)
            throw new Error("The parameter 'dataToInclude' cannot be null.");
        else if (dataToInclude !== undefined)
            dataToInclude && dataToInclude.forEach(item => { url_ += "dataToInclude=" + encodeURIComponent("" + item) + "&"; });
        if (processListingGroup !== undefined && processListingGroup !== null)
            url_ += "processListingGroup=" + encodeURIComponent("" + processListingGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsSectionalDataForEvents(_response);
        });
    }

    protected processGetListingsSectionalDataForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    getRetailSaleListingTicketsForEvents(input: SectionalListingsForEventsInput, signal?: AbortSignal | undefined): Promise<RetailSaleListingTickets[]> {
        let url_ = this.baseUrl + "/api/Listing/GetRetailSaleListingTicketsForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRetailSaleListingTicketsForEvents(_response);
        });
    }

    protected processGetRetailSaleListingTicketsForEvents(response: Response): Promise<RetailSaleListingTickets[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RetailSaleListingTickets[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetailSaleListingTickets[]>(null as any);
    }

    getListingsCanBeWasted(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<ValueTupleOfBooleanAndIListOfTicket> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsCanBeWasted?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsCanBeWasted(_response);
        });
    }

    protected processGetListingsCanBeWasted(response: Response): Promise<ValueTupleOfBooleanAndIListOfTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfBooleanAndIListOfTicket;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfBooleanAndIListOfTicket>(null as any);
    }

    getDuplicateListingsForListingId(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<DuplicateListingDetails[]> {
        let url_ = this.baseUrl + "/api/Listing/GetDuplicateListingsForListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDuplicateListingsForListingId(_response);
        });
    }

    protected processGetDuplicateListingsForListingId(response: Response): Promise<DuplicateListingDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DuplicateListingDetails[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicateListingDetails[]>(null as any);
    }

    getListingEnabledForAutoPricing(posEventIds: string[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/GetListingEnabledForAutoPricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posEventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingEnabledForAutoPricing(_response);
        });
    }

    protected processGetListingEnabledForAutoPricing(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateAutoPricingEnabledForEvent(posEventIds: string[], autoPricingState: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/UpdateAutoPricingEnabledForEvent?";
        if (autoPricingState === null)
            throw new Error("The parameter 'autoPricingState' cannot be null.");
        else if (autoPricingState !== undefined)
            url_ += "autoPricingState=" + encodeURIComponent("" + autoPricingState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posEventIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAutoPricingEnabledForEvent(_response);
        });
    }

    protected processUpdateAutoPricingEnabledForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/CreateMarketplaceListings?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaces);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMarketplaceListings(_response);
        });
    }

    protected processCreateMarketplaceListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/DeleteMarketplaceListings?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaces);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMarketplaceListings(_response);
        });
    }

    protected processDeleteMarketplaceListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingAdminHold(listingId: number | undefined, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAdminHold?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (adminHoldExpirationDate !== undefined && adminHoldExpirationDate !== null)
            url_ += "adminHoldExpirationDate=" + encodeURIComponent("" + adminHoldExpirationDate) + "&";
        if (adminHoldNotes !== undefined && adminHoldNotes !== null)
            url_ += "adminHoldNotes=" + encodeURIComponent("" + adminHoldNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAdminHold(_response);
        });
    }

    protected processUpdateListingAdminHold(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingIgnoreDuplicate(listingId: number | undefined, ignoreDuplicate: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingIgnoreDuplicate?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (ignoreDuplicate === null)
            throw new Error("The parameter 'ignoreDuplicate' cannot be null.");
        else if (ignoreDuplicate !== undefined)
            url_ += "ignoreDuplicate=" + encodeURIComponent("" + ignoreDuplicate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingIgnoreDuplicate(_response);
        });
    }

    protected processUpdateListingIgnoreDuplicate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingByListingId(listingId: number, input: ListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingByListingId(_response);
        });
    }

    protected processUpdateListingByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingPrices(listingId: number | undefined, listPrice: number | undefined, netProceedsFloor: number | undefined, signal?: AbortSignal | undefined): Promise<Listing> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPrices?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (listPrice === null)
            throw new Error("The parameter 'listPrice' cannot be null.");
        else if (listPrice !== undefined)
            url_ += "listPrice=" + encodeURIComponent("" + listPrice) + "&";
        if (netProceedsFloor === null)
            throw new Error("The parameter 'netProceedsFloor' cannot be null.");
        else if (netProceedsFloor !== undefined)
            url_ += "netProceedsFloor=" + encodeURIComponent("" + netProceedsFloor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPrices(_response);
        });
    }

    protected processUpdateListingPrices(response: Response): Promise<Listing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing>(null as any);
    }

    updateListingsPricingSettingsByListingId(listingId: number, input: ValueTupleOfLongAndListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<Listing> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingsPricingSettingsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingsPricingSettingsByListingId(_response);
        });
    }

    protected processUpdateListingsPricingSettingsByListingId(response: Response): Promise<Listing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing>(null as any);
    }

    mergeListingsWithListingId(listingId: number, input: MergeListingsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/MergeListingsWithListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListingsWithListingId(_response);
        });
    }

    protected processMergeListingsWithListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    bulkMergeListings(input: BulkMergeListingsInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/BulkMergeListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeListings(_response);
        });
    }

    protected processBulkMergeListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getMergedListingSectionTypeResolutions(listingIdLists: number[][], signal?: AbortSignal | undefined): Promise<MergedListingSectionTypeResolutionResult[]> {
        let url_ = this.baseUrl + "/api/Listing/GetMergedListingSectionTypeResolutions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingIdLists);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMergedListingSectionTypeResolutions(_response);
        });
    }

    protected processGetMergedListingSectionTypeResolutions(response: Response): Promise<MergedListingSectionTypeResolutionResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MergedListingSectionTypeResolutionResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergedListingSectionTypeResolutionResult[]>(null as any);
    }

    getListingMergeSuggestionsByEvent(viagogoEventId: number | undefined, excludeHeldListings: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<ListingMergeSuggestion[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingMergeSuggestionsByEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingMergeSuggestionsByEvent(_response);
        });
    }

    protected processGetListingMergeSuggestionsByEvent(response: Response): Promise<ListingMergeSuggestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMergeSuggestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMergeSuggestion[]>(null as any);
    }

    getListingMergeSuggestions(excludeHeldListings: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<ListingMergeSuggestion[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingMergeSuggestions?";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingMergeSuggestions(_response);
        });
    }

    protected processGetListingMergeSuggestions(response: Response): Promise<ListingMergeSuggestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMergeSuggestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMergeSuggestion[]>(null as any);
    }

    splitListingsByListingId(listingId: number, input: SplitListingInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/SplitListingsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSplitListingsByListingId(_response);
        });
    }

    protected processSplitListingsByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateBarcodesForListing(listingId: number | undefined, barcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateBarcodesForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(barcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBarcodesForListing(_response);
        });
    }

    protected processUpdateBarcodesForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateETicketsForListing(listingId: number | undefined, etickets: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateETicketsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(etickets);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateETicketsForListing(_response);
        });
    }

    protected processUpdateETicketsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateMobileQRCodesForListing(listingId: number | undefined, mobileQRCodes: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateMobileQRCodesForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileQRCodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMobileQRCodesForListing(_response);
        });
    }

    protected processUpdateMobileQRCodesForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateExternalIdsForListing(listingId: number | undefined, externalIds: TicketExternalId[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateExternalIdsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateExternalIdsForListing(_response);
        });
    }

    protected processUpdateExternalIdsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateTicketUrlsForListing(listingId: number | undefined, ticketUrls: TicketUrl[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateTicketUrlsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketUrls);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketUrlsForListing(_response);
        });
    }

    protected processUpdateTicketUrlsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateProofOfPurchaseForListing(listingId: number | undefined, proofDocs: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateProofOfPurchaseForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proofDocs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProofOfPurchaseForListing(_response);
        });
    }

    protected processUpdateProofOfPurchaseForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getPriceHistoryByListingIdWithListingId(listingId: number, input: ValueTupleOfLongAndNullableInteger, signal?: AbortSignal | undefined): Promise<ListingPriceHistory[]> {
        let url_ = this.baseUrl + "/api/Listing/GetPriceHistoryByListingIdWithListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriceHistoryByListingIdWithListingId(_response);
        });
    }

    protected processGetPriceHistoryByListingIdWithListingId(response: Response): Promise<ListingPriceHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingPriceHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingPriceHistory[]>(null as any);
    }

    getCompListingsByEventId(viagogoEventId: number | undefined, listingId: number | null | undefined, currency: string | null | undefined, signal?: AbortSignal | undefined): Promise<CompListing[]> {
        let url_ = this.baseUrl + "/api/Listing/GetCompListingsByEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompListingsByEventId(_response);
        });
    }

    protected processGetCompListingsByEventId(response: Response): Promise<CompListing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompListing[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompListing[]>(null as any);
    }

    getListingPriceCalculation(viagogoEventId: number | undefined, listingId: number | undefined, officeId: number | null | undefined, input: ListingDetailsPricingUpdates, signal?: AbortSignal | undefined): Promise<ListingPriceCalculation> {
        let url_ = this.baseUrl + "/api/Listing/GetListingPriceCalculation?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (officeId !== undefined && officeId !== null)
            url_ += "officeId=" + encodeURIComponent("" + officeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingPriceCalculation(_response);
        });
    }

    protected processGetListingPriceCalculation(response: Response): Promise<ListingPriceCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingPriceCalculation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingPriceCalculation>(null as any);
    }

    exportListings(input: ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/ExportListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportListings(_response);
        });
    }

    protected processExportListings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createSeatSaver(inputs: SeatSaverListingDetailsInput[], signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        let url_ = this.baseUrl + "/api/Listing/CreateSeatSaver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSeatSaver(_response);
        });
    }

    protected processCreateSeatSaver(response: Response): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfIEnumerableOfNullableLong;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfIEnumerableOfNullableLong>(null as any);
    }

    deleteSeatSaver(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/DeleteSeatSaver?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSeatSaver(_response);
        });
    }

    protected processDeleteSeatSaver(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    batchSwapListingGroup(input: BatchSwapListingGroupInput, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/Listing/BatchSwapListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchSwapListingGroup(_response);
        });
    }

    protected processBatchSwapListingGroup(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    reorderListingInGroup(input: ReorderListingInGroupInput, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/Listing/ReorderListingInGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderListingInGroup(_response);
        });
    }

    protected processReorderListingInGroup(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    updateListingBroadcastSectionByListingId(listingId: number, input: ListingDetailsBroadcastSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingBroadcastSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingBroadcastSectionByListingId(_response);
        });
    }

    protected processUpdateListingBroadcastSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingTicketSectionByListingId(listingId: number, input: ListingDetailsTicketSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTicketSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTicketSectionByListingId(_response);
        });
    }

    protected processUpdateListingTicketSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingPricingSectionFromListingTable(listingId: number, input: ListingPricingSectionPosFieldUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPricingSectionFromListingTable/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPricingSectionFromListingTable(_response);
        });
    }

    protected processUpdateListingPricingSectionFromListingTable(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingPricingSectionByListingId(listingId: number, input: ListingDetailsPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPricingSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPricingSectionByListingId(_response);
        });
    }

    protected processUpdateListingPricingSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingAutoPricingSectionByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSectionByListingId(_response);
        });
    }

    protected processUpdateListingAutoPricingSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingAutoPricingSectionV2ByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdatesV2, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSectionV2ByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSectionV2ByListingId(_response);
        });
    }

    protected processUpdateListingAutoPricingSectionV2ByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingTagSectionByListingId(listingId: number, input: ListingDetailsTagsSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTagSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTagSectionByListingId(_response);
        });
    }

    protected processUpdateListingTagSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    downloadMergedUserDocumentsPdf(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/DownloadMergedUserDocumentsPdf?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getListingStatusByListingId(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<ListingStatusInfo> {
        let url_ = this.baseUrl + "/api/Listing/GetListingStatusByListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingStatusByListingId(_response);
        });
    }

    protected processGetListingStatusByListingId(response: Response): Promise<ListingStatusInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingStatusInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatusInfo>(null as any);
    }

    getListingStatusByListingIds(inventoryIds: number[], signal?: AbortSignal | undefined): Promise<(ListingStatusInfo | null)[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingStatusByListingIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingStatusByListingIds(_response);
        });
    }

    protected processGetListingStatusByListingIds(response: Response): Promise<(ListingStatusInfo | null)[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as (ListingStatusInfo | null)[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<(ListingStatusInfo | null)[]>(null as any);
    }

    getLastBroadcastListingMarketplaceByListingId(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<Marketplace[]> {
        let url_ = this.baseUrl + "/api/Listing/GetLastBroadcastListingMarketplaceByListingId?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastBroadcastListingMarketplaceByListingId(_response);
        });
    }

    protected processGetLastBroadcastListingMarketplaceByListingId(response: Response): Promise<Marketplace[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Marketplace[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marketplace[]>(null as any);
    }

    downloadSeatSaversFileTemplate(includeEventIdFields: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/DownloadSeatSaversFileTemplate/DownloadSeatSaversFileTemplate?";
        if (includeEventIdFields === null)
            throw new Error("The parameter 'includeEventIdFields' cannot be null.");
        else if (includeEventIdFields !== undefined)
            url_ += "includeEventIdFields=" + encodeURIComponent("" + includeEventIdFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSeatSaversFileTemplate(_response);
        });
    }

    protected processDownloadSeatSaversFileTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    changeListingOffice(input: ChangeListingOfficeInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfLong> {
        let url_ = this.baseUrl + "/api/Listing/ChangeListingOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeListingOffice(_response);
        });
    }

    protected processChangeListingOffice(response: Response): Promise<PosUiActionResultWithDataOfLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfLong;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfLong>(null as any);
    }
}
export interface IListingExperimentClient {

    getListingExperimentsByViagogoEventId(viagogoEventId: number | undefined): Promise<ListingExperiment[]>;

    createListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    updateListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    restartListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    stopListingExperiment(viagogoEventId: number | undefined, listingGroupId: string | null | undefined): Promise<boolean>;
}

export class ListingExperimentClient extends PosClientBase implements IListingExperimentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getListingExperimentsByViagogoEventId(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<ListingExperiment[]> {
        let url_ = this.baseUrl + "/api/ListingExperiment/GetListingExperimentsByViagogoEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingExperimentsByViagogoEventId(_response);
        });
    }

    protected processGetListingExperimentsByViagogoEventId(response: Response): Promise<ListingExperiment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingExperiment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingExperiment[]>(null as any);
    }

    createListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/CreateListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateListingExperiment(_response);
        });
    }

    protected processCreateListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/UpdateListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingExperiment(_response);
        });
    }

    protected processUpdateListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    restartListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/RestartListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestartListingExperiment(_response);
        });
    }

    protected processRestartListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    stopListingExperiment(viagogoEventId: number | undefined, listingGroupId: string | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/StopListingExperiment?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingGroupId !== undefined && listingGroupId !== null)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStopListingExperiment(_response);
        });
    }

    protected processStopListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}
export interface IListingGroupClient {

    ungroupListings(listingGroupId: string | undefined): Promise<{ [key: string]: Listing[]; }>;

    setListingActiveInGroup(listingGroupId: string | undefined, listingId: number | undefined, isActive: boolean | undefined): Promise<boolean>;

    createListingGroup(input: MergeListingGroupInput): Promise<boolean>;

    updateListingGroup(listingGroupId: string | undefined, input: MergeListingGroupInput): Promise<boolean>;

    getEmptyListingGroup(): Promise<ListingGroup>;

    autoCompSettingsPreview(input: AutoCompSettingsPreviewInput): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview>;

    autoGroupListingsPreview(input: AutoGroupListingsPreviewInput): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview>;

    autoGroupListingsPreviewV2(input: AutoGroupListingsPreviewInput): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput>;
}

export class ListingGroupClient extends PosClientBase implements IListingGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    ungroupListings(listingGroupId: string | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/ListingGroup/UngroupListings?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUngroupListings(_response);
        });
    }

    protected processUngroupListings(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    setListingActiveInGroup(listingGroupId: string | undefined, listingId: number | undefined, isActive: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/SetListingActiveInGroup?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetListingActiveInGroup(_response);
        });
    }

    protected processSetListingActiveInGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createListingGroup(input: MergeListingGroupInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/CreateListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateListingGroup(_response);
        });
    }

    protected processCreateListingGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingGroup(listingGroupId: string | undefined, input: MergeListingGroupInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/UpdateListingGroup?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingGroup(_response);
        });
    }

    protected processUpdateListingGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getEmptyListingGroup(signal?: AbortSignal | undefined): Promise<ListingGroup> {
        let url_ = this.baseUrl + "/api/ListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyListingGroup(_response);
        });
    }

    protected processGetEmptyListingGroup(response: Response): Promise<ListingGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingGroup>(null as any);
    }

    autoCompSettingsPreview(input: AutoCompSettingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoCompSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoCompSettingsPreview(_response);
        });
    }

    protected processAutoCompSettingsPreview(response: Response): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfAutoCompListingsPreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfAutoCompListingsPreview>(null as any);
    }

    autoGroupListingsPreview(input: AutoGroupListingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoGroupListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoGroupListingsPreview(_response);
        });
    }

    protected processAutoGroupListingsPreview(response: Response): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfAutoGroupListingsPreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfAutoGroupListingsPreview>(null as any);
    }

    autoGroupListingsPreviewV2(input: AutoGroupListingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoGroupListingsPreviewV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoGroupListingsPreviewV2(_response);
        });
    }

    protected processAutoGroupListingsPreviewV2(response: Response): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput>(null as any);
    }
}
export interface IListingNoteClient {

    getAccessibleListingNotes(): Promise<ListingNote[]>;
}

export class ListingNoteClient extends PosClientBase implements IListingNoteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccessibleListingNotes(signal?: AbortSignal | undefined): Promise<ListingNote[]> {
        let url_ = this.baseUrl + "/api/ListingNote/GetAccessibleListingNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleListingNotes(_response);
        });
    }

    protected processGetAccessibleListingNotes(response: Response): Promise<ListingNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingNote[]>(null as any);
    }
}
export interface IListingsAggregationOpenSearchClient {

    summary(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2): Promise<ListingAggregationResponse>;

    byCurrency(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2): Promise<{ [key: string]: ListingAggregationSummary; }>;

    uIList(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2): Promise<EntitiesWithSummaryOfListingWithCatalogData>;
}

export class ListingsAggregationOpenSearchClient extends PosClientBase implements IListingsAggregationOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    summary(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2, signal?: AbortSignal | undefined): Promise<ListingAggregationResponse> {
        let url_ = this.baseUrl + "/api/OpenSearch/ListingsAggregation/Summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<ListingAggregationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingAggregationResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingAggregationResponse>(null as any);
    }

    byCurrency(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2, signal?: AbortSignal | undefined): Promise<{ [key: string]: ListingAggregationSummary; }> {
        let url_ = this.baseUrl + "/api/OpenSearch/ListingsAggregation/ByCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processByCurrency(_response);
        });
    }

    protected processByCurrency(response: Response): Promise<{ [key: string]: ListingAggregationSummary; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: ListingAggregationSummary; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ListingAggregationSummary; }>(null as any);
    }

    uIList(request: MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfListingWithCatalogData> {
        let url_ = this.baseUrl + "/api/OpenSearch/ListingsAggregation/UIList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUIList(_response);
        });
    }

    protected processUIList(response: Response): Promise<EntitiesWithSummaryOfListingWithCatalogData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfListingWithCatalogData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfListingWithCatalogData>(null as any);
    }
}
export interface IListingsOpenSearchClient {

    searchListingsV3(request: ListingSearchRequestV2): Promise<SecureListingSearchMappedResult>;
}

export class ListingsOpenSearchClient extends PosClientBase implements IListingsOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    searchListingsV3(request: ListingSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecureListingSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchListingsV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsV3(_response);
        });
    }

    protected processSearchListingsV3(response: Response): Promise<SecureListingSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecureListingSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureListingSearchMappedResult>(null as any);
    }
}
